// components/InterviewGuardAlertModal.jsx
import { AlertTriangle } from "lucide-react"
import icon from "../assets/interviewguard.png"

const FF   = "'DM Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif"
const MONO = "'IBM Plex Mono', monospace"

const T = {
  border:       "0.5px solid #e5e7eb",
  radius:       8,
  radiusCard:   10,
  bg:           "#fff",
  bgMuted:      "#fafaf9",
  text:         "#111827",
  textMuted:    "#374151",
  textTertiary: "#6b7280",
  shadow:       "0 1px 3px rgba(0,0,0,0.06), 0 1px 2px rgba(0,0,0,0.04)",
}

const InterviewGuardAlertModal = ({ isVisible, message, onDismiss }) => {
  if (!isVisible) return null

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.32)",
        backdropFilter: "blur(2px)",
        zIndex: 60,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 16,
        fontFamily: FF,
      }}
    >
      <div
        style={{
          background: T.bg,
          border: T.border,
          borderRadius: T.radiusCard + 2,
          boxShadow: "0 8px 32px rgba(0,0,0,0.12), 0 2px 8px rgba(0,0,0,0.06)",
          width: "100%",
          maxWidth: 400,
          overflow: "hidden",
        }}
      >
        {/* Header strip */}
        <div
          style={{
            padding: "13px 20px",
            background: T.bgMuted,
            borderBottom: T.border,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <div
              style={{
                width: 7,
                height: 7,
                borderRadius: "50%",
                background: "#ef4444",
                flexShrink: 0,
              }}
            />
            <span
              style={{
                fontSize: 11,
                fontWeight: 700,
                textTransform: "uppercase",
                letterSpacing: "0.08em",
                color: T.textTertiary,
                fontFamily: MONO,
              }}
            >
              Integrity alert
            </span>
          </div>
        </div>

        {/* Body */}
        <div style={{ padding: "24px 24px 20px" }}>
          {/* Icon */}
          <div
            style={{
              width: 40,
              height: 40,
              borderRadius: T.radiusCard,
              border: T.border,
              background: "#fef2f2",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginBottom: 16,
              boxShadow: T.shadow,
            }}
          >
            <img
              src={icon}
              alt="InterviewGuard"
              style={{ width: 20, height: 20, objectFit: "contain", borderRadius: 4 }}
            />
          </div>

          {/* Title */}
          <p
            style={{
              margin: "0 0 6px",
              fontSize: 15,
              fontWeight: 700,
              color: T.text,
              letterSpacing: "-0.02em",
              fontFamily: FF,
            }}
          >
            Suspicious activity detected
          </p>

          {/* Message box */}
          <div
            style={{
              display: "flex",
              alignItems: "flex-start",
              gap: 8,
              padding: "10px 12px",
              background: "#fef2f2",
              border: "0.5px solid #fecaca",
              borderRadius: T.radius,
              marginBottom: 14,
            }}
          >
            <AlertTriangle size={13} color="#ef4444" strokeWidth={1.5} style={{ marginTop: 1, flexShrink: 0 }} />
            <p
              style={{
                margin: 0,
                fontSize: 13,
                fontWeight: 500,
                color: "#991b1b",
                lineHeight: 1.6,
                fontFamily: FF,
              }}
            >
              {message}
            </p>
          </div>

          {/* Sub note */}
          <p
            style={{
              margin: "0 0 22px",
              fontSize: 11,
              color: T.textTertiary,
              lineHeight: 1.6,
              fontFamily: MONO,
            }}
          >
            An integrity violation was detected on the candidate's device. A report has been logged across partner platforms.
          </p>

          {/* Action */}
          <button
            onClick={onDismiss}
            style={{
              width: "100%",
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              height: 38,
              padding: "0 18px",
              borderRadius: T.radius,
              border: T.border,
              background: T.bg,
              color: T.text,
              fontSize: 13,
              fontWeight: 600,
              fontFamily: FF,
              cursor: "pointer",
              transition: "background 0.12s",
              outline: "none",
            }}
            onMouseEnter={(e) => { e.currentTarget.style.background = T.bgMuted }}
            onMouseLeave={(e) => { e.currentTarget.style.background = T.bg }}
          >
            Acknowledge
          </button>
        </div>
      </div>
    </div>
  )
}

export default InterviewGuardAlertModal